<template>
  <div id="company_info" class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>查看領款單</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="row">
      <h4 class="col-md-3">實際領款日期: {{ actualWithdrawalDate }}</h4>
      <h4 class="col-md-2">司機名稱: {{ callNumber }}-{{ name }}</h4>
    </div>
    <hr />
    <!-- <div class="row"> -->
    <h4>費用:</h4>
    <el-table :data="feeItme" height="250" border style="width: 100%">
      <el-table-column
        prop="name"
        label="費用項目"
        width="180"
      ></el-table-column>
      <el-table-column
        prop="createdAt"
        label="建立日期"
        width="180"
      ></el-table-column>
      <el-table-column prop="totalFee" label="總金額"></el-table-column>
      <el-table-column prop="serviceFee" label="手續費"></el-table-column>
      <el-table-column
        prop="actualFee"
        label="實際金額(金額-手續費)"
      ></el-table-column>
      <el-table-column prop="note" label="備註"></el-table-column>
    </el-table>
    <!-- </div> -->
    <hr />
    <div class="row">
      <h4>企業簽單:{{ signingList.length }}張</h4>
      <table class="table table-striped jambo_table bulk_action">
        <thead>
          <tr class="headings fontSize16">
            <th class="column-title">公司名稱</th>
            <th class="column-title">訂單時間</th>
            <th class="column-title">上車地點</th>
            <th class="column-title">下車地點</th>
            <th class="column-title">訂單種類</th>
            <th class="column-title">司機填入金額</th>
            <th class="column-title">車隊服務金額</th>
            <th class="column-title">工號-員工姓名</th>
            <th class="column-title">簽名檔</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(bill, index) in signingList">
            <tr class="pointer fontSize16" @click="showSigningList(invoice.id)">
              <td>{{ bill.companyName }}</td>
              <td>{{ bill.createdAt }}</td>
              <td>{{ bill.onAddress }}</td>
              <td>{{ bill.offAddress }}</td>
              <td>{{ bill.type }}</td>
              <td>{{ bill.actualFare }}</td>
              <td>{{ bill.serviceFee }}</td>
              <td>{{ bill.employeeNameJobNumber }}</td>
              <td class=" ">
                <template v-for="(item, index) in bill.employeePhoto">
                  <img width="120" height="100" :src="item" />
                </template>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <hr />
    <div class="row">
      <h4>領款單備註: {{ note }}</h4>
    </div>
    <SigningListInWithdrawalModal
      ref="signingListInWithdrawalModal"
      :optSigningDetailList="optSigningDetailList"
    ></SigningListInWithdrawalModal>
  </div>
</template>
<script>
import SigningListInWithdrawalModal from '@/components/company/SigningListInWithdrawalModal'
import EnterpriseAPI from '../../assets/js/libs/EnterpriseAPI'
import moment from 'moment'

export default {
  components: {
    SigningListInWithdrawalModal,
  },
  data() {
    return {
      callNumber: '',
      name: '',
      note: '',
      actualWithdrawalDate: '',
      feeItme: [],
      invoiceList: [],
      signingList: [],
      optSigningDetailList: [],
      withdrawalId: '',
      driverId: 0,
      signingList: [],
    }
  },
  mounted() {
    this.withdrawalId = this.$route.params.id
    this.name = this.$route.query.name
    this.callNumber = this.$route.query.callNumber
    this.actualWithdrawalDate = this.$route.query.actualWithdrawalDate
    this.note = this.$route.query.note
    this.driverId = this.$route.query.driverId
    this.getDriverWithdrawalFeeItem()
    this.getDriverInvoiceList()
  },
  methods: {
    showSigningList(id) {
      EnterpriseAPI.get(
        `enterprise/invoice?task=invoiceId&driverId=${this.driverId}&invoiceId=${id}&invoiceType=FinishPayment`,
      )
        .then((res) => {
          this.signingList = res.result.signingList
          this.$refs.signingListInWithdrawalModal.showModal(
            id,
            this.signingList,
            [],
          )
        })
        .catch((err) => {
          console.log(err)
          this.$msg('網路連線異常')
        })
    },
    addFareItem() {
      this.withdrawals.push(1)
    },
    getDriverWithdrawalFeeItem() {
      EnterpriseAPI.get(
        `enterprise/withdrawal/item?withdrawalid=${this.withdrawalId}`,
      )
        .then((res) => {
          this.feeItme = res.result.list
        })
        .catch((err) => {
          console.log('intersectionInfo', err)
        })
    },
    getDriverInvoiceList() {
      EnterpriseAPI.get(
        `enterprise/invoice?task=withdrawal&withdrawalId=${this.withdrawalId}`,
      )
        .then((res) => {
          // this.invoiceList = res.result.invoiceList
          this.signingList = res.result.signingList
          // console.log(this.invoiceList)
        })
        .catch((err) => {
          console.log('intersectionInfo', err)
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/company/EditWithdrawal.vue